module.exports = __webpack_public_path__ + "static/img/br.708596f3.svg";